import store from '@/store/store'
import PigStyApi from "@/api/pigStyApi";
import axios from '@/api/baseApi.js'
import DeliveryNoteApi from '@/api/delivery-note/delivery-note.js'

const BACKGROUND_RELOAD_INTERVAL = 2 * 60 * 1000 // 2 min

let timeout = null

const fetchInfo = {
  loading: false,
  lastFetched: null,
  data: []
}

store.registerModule('pwa', {
  state: {
    online: true,
    pigSty: {...fetchInfo},
    deliveries: {
      piglet: {
        config: {
          'delivery-addition': {...fetchInfo},
          transport: {...fetchInfo},
          transportAll: {...fetchInfo},
          transporter: {...fetchInfo},
          article: {...fetchInfo},
          'marketing-fee': {...fetchInfo},
          addition: {...fetchInfo},
          slaughterHouse: {...fetchInfo},
          qualityPrograms: {...fetchInfo},
          veterinarians: {...fetchInfo},
          countries: {...fetchInfo},
          states: {...fetchInfo}
        },
        details: {}
      },
      pigSty: {
        config: {
          article: {...fetchInfo}
        }
      }
    },
    deliveryNotes: {},
  },

  mutations: {
    APP_ONLINE(state, online) {
      state.online = online
      if (online) {
        this.dispatch('APP_FETCH_BACKGROUND_DATA')
      }
    },
    APP_PIGSTY_LOADING(state, loading = true) {
      state.pigSty.loading = loading
    },
    APP_PIGSTY_LOADED(state, data) {
      state.pigSty.lastFetched = Math.round((new Date()).getTime() / 1000),
        state.pigSty.loading = false
      state.pigSty.data = data
    },
    APP_DELIVERY_CONFIG_LOADING(state, {key, context, loading}) {
      state.deliveries[context].config[key].loading = loading
    },
    APP_DELIVERY_CONFIG_LOADED(state, {key, context, data}) {
      state.deliveries[context].config[key].lastFetched = Math.round((new Date()).getTime() / 1000)
      state.deliveries[context].config[key].loading = false
      state.deliveries[context].config[key].data = data
    },
    APP_DELIVERY_LOADING(state, {context, id, loading}) {
      if (typeof state.deliveries[context].details[id] === 'undefined') {
        state.deliveries[context].details = {
          ...state.deliveries[context].details,
          [id]: {...fetchInfo},
        }
      }
      state.deliveries[context].details[id].loading = loading
    },
    APP_DELIVERY_LOADED(state, {context, id, data}) {
      if (typeof state.deliveries[context].details[id] === 'undefined') {
        state.deliveries[context].details = {
          ...state.deliveries[context].details,
          [id]: {...fetchInfo},
        }
      }
      state.deliveries[context].details[id].lastFetched = Math.round((new Date()).getTime() / 1000),
        state.deliveries[context].details[id].loading = false
      state.deliveries[context].details[id].data = data
    },
    APP_DELIVERY_NOTE_LOADING(state, {id, loading}) {
      if (typeof state.deliveryNotes[id] === 'undefined') {
        state.deliveryNotes = {
          ...state.deliveryNotes,
          [id]: {...fetchInfo},
        }
      }
      state.deliveryNotes[id].loading = loading
    },
    APP_DELIVERY_NOTE_LOADED(state, {id, data}) {
      if (typeof state.deliveryNotes[id] === 'undefined') {
        state.deliveryNotes = {
          ...state.deliveryNotes,
          [id]: {...fetchInfo},
        }
      }
      state.deliveryNotes[id].lastFetched = Math.round((new Date()).getTime() / 1000),
        state.deliveryNotes[id].loading = false
      state.deliveryNotes[id].data = data
    },
  },

  actions: {
    async APP_INIT({dispatch}) {
      dispatch('APP_FETCH_BACKGROUND_DATA')
      dispatch('APP_FETCH_DELIVERY_CONFIG_ALL')
    },

    async APP_FETCH_PIGSTY({commit}) {
      commit('APP_PIGSTY_LOADING')

      try {
        const response = await PigStyApi.fetch();
        commit('APP_PIGSTY_LOADED', response.data)

      } catch (error) {
        commit('APP_PIGSTY_LOADING', false)
        return Promise.reject(error);
      }
    },

    async APP_FETCH_DELIVERY_CONFIG({commit}, {key, context}) {
      const urlMapping = {
        'delivery-addition': `/api-${context}/api/delivery-addition/${context}/v1`,
        transport: `/api-piglet/api/transport/v1?onlyFavourites=true`,
        transportAll: `/api-article/v1/transporter`,
        transporter: `/api-master-data/transporter/license-plates/v1`,
        article: `/api-${context}/api/article/${context}/v1`,
        'marketing-fee': `/api-${context}/api/marketing-fee/v1`,
        addition: `/api-${context}/api/addition/v1`,
        slaughterHouse: `/api-master-data/v1/slaughter-house/v1`,
        qualityPrograms: `/api-article/v1/quality-programs`,
        veterinarians: `/api-master-data/v1/factory/veterinarian/details`,
        countries: `/api-master-data/v1/country`,
        states: `/api-master-data/v1/state`,
      }
      if (typeof urlMapping[key] === 'undefined') {
        throw new Error(`unknown delivery config: ${key}`)
      }

      const url = urlMapping[key]

      commit('APP_DELIVERY_CONFIG_LOADING', {key, context, loading: true})

      try {
        const res = await axios.get(url)
        commit('APP_DELIVERY_CONFIG_LOADED', {key, context, data: res.data})
      } catch (error) {
        commit('APP_DELIVERY_CONFIG_LOADING', {key, context, loading: false})
        return Promise.reject(error);
      }
    },
    async APP_FETCH_DATA({commit}, {key, context, action}) {
      commit('APP_DELIVERY_CONFIG_LOADING', {key, context, loading: true})
      try {
        const data = await action();
        commit('APP_DELIVERY_CONFIG_LOADED', {key, context, data: data})
        return Promise.resolve();
      } catch (error) {
        commit('APP_DELIVERY_CONFIG_LOADING', {key, context, loading: false});
        return Promise.reject(error);
      }
    },
    async APP_FETCH_DELIVERY_CONFIG_ALL({dispatch}) {
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'delivery-addition'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'transport'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'transportAll'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'transporter'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'article'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'marketing-fee'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'addition'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'slaughterHouse'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'qualityPrograms'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'countries'})
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'states'})
      dispatch('APP_FETCH_DATA', {
        context: 'pigSty', key: 'article', action: async () =>
          [{id: 1, name: "MS", description: "Mastschwein"}, {id: 2, name: "E", description: "Eber"}, {
            id: 3,
            name: "Z",
            description: "Zucht"
          }]
      })
      dispatch('APP_FETCH_DELIVERY_CONFIG', {context: 'piglet', key: 'veterinarians'})
    },
    async APP_FETCH_DELIVERY({commit}, {context, id}) {
      commit('APP_DELIVERY_LOADING', {context, id, loading: true})
      try {
        const res = await axios.get(`/api-${context}/api/delivery/v1/${id}`)
        commit('APP_DELIVERY_LOADED', {context, id, data: res.data})
      } catch (error) {
        commit('APP_DELIVERY_LOADING', {context, id, loading: false})
        return Promise.reject(error);
      }
    },

    async APP_FETCH_DELIVERY_NOTE({commit}, id) {
      commit('APP_DELIVERY_NOTE_LOADING', {id, loading: true})

      try {
        const res = await DeliveryNoteApi.get(id)
        commit('APP_DELIVERY_NOTE_LOADED', {id, data: res.data})
      } catch (error) {
        commit('APP_DELIVERY_NOTE_LOADING', {id, loading: false})
        return Promise.reject(error);
      }
    },

    async APP_FETCH_BACKGROUND_DATA({state, dispatch}) {
      if (timeout) {
        window.clearTimeout(timeout)
      }

      if (!state.online) {
        timeout = setTimeout(() => dispatch('APP_FETCH_BACKGROUND_DATA'), BACKGROUND_RELOAD_INTERVAL)
        return
      }
      console.debug('fetching background data')
      Promise.all([
        dispatch('APP_FETCH_PIGSTY'),
      ]).then(() => {
        console.debug('background data loaded')
      }).catch(error => {
        console.error('error while loading background data', error)
      }).finally(() => {
        timeout = setTimeout(() => dispatch('APP_FETCH_BACKGROUND_DATA'), BACKGROUND_RELOAD_INTERVAL)
      })
    }
  },

  getters: {
    backgroundDataLoading(state) {
      return state.pigSty.loading
        || state.deliveries.piglet.loading
    },
  }
})

export default store
